import { AuditActionCode, AuditResourceType } from "@CommonUtils/AuditActionCodes";
import { AUDIT_ACTION_CODE_LABELS, AUDIT_RESOURCE_TYPE_LABELS } from "./labels";

export const ACTION_CODE_OPTIONS = [
  { label: "All Actions", value: "" as const },
  ...Object.values(AuditActionCode)
    .map((code) => ({ label: AUDIT_ACTION_CODE_LABELS[code], value: code }))
    .sort((a, b) => a.label.localeCompare(b.label)),
];

export const RESOURCE_TYPE_OPTIONS = [
  { label: "All Resources", value: "" as const },
  ...Object.values(AuditResourceType)
    .map((type) => ({ label: AUDIT_RESOURCE_TYPE_LABELS[type], value: type }))
    .sort((a, b) => a.label.localeCompare(b.label)),
];

export const STATUS_OPTIONS = [
  { label: "All Statuses", value: "" as const },
  { label: "Success", value: "success" as const },
  { label: "Failure", value: "failure" as const },
];

export const PAGE_SIZE = 25;
